export class AcceptanceAccount {
    acceptanceAccountId: number;
    acceptanceAccountProvider: string;
    merchantId: number;
    id: number;
    posId: number;
    supplierId: number;
    issuerType: string;
    createdDate : string;
	providerSpecificParameters: Map<String, String>;
    deleted: string;
}
